import React, { useEffect, useRef } from 'react';
import Quill from 'quill';
import 'quill/dist/quill.snow.css';

const QuillWrapper = ({ value, onChange, modules }) => {
  const editorContainerRef = useRef(null);
  const quillInstanceRef = useRef(null);
  const onChangeRef = useRef(onChange);

  useEffect(() => {
    onChangeRef.current = onChange;
  }, [onChange]);

  // useEffect(() => {
  //   const adjustTooltipPosition = () => {
  //     const tooltip = document.querySelector('.ql-tooltip');
  //     if (tooltip) {
  //       const left = parseFloat(tooltip.style.left) || 0;
  //       if (left < 0) {
  //         tooltip.style.left = '10px';
  //       }
  //     }
  //   };

  //   const observer = new MutationObserver(adjustTooltipPosition);
  //   const editorContainer = document.querySelector('.ql-container');

  //   if (editorContainer) {
  //     observer.observe(editorContainer, {
  //       childList: true,
  //       subtree: true,
  //       attributes: true,
  //     });
  //   }

  //   return () => {
  //     observer.disconnect();
  //   };
  // }, []);

  useEffect(() => {
    if (editorContainerRef.current && !quillInstanceRef.current) {
      quillInstanceRef.current = new Quill(editorContainerRef.current, {
        theme: 'snow',
        modules: modules,
        bounds: editorContainerRef.current,
      });

      const quill = quillInstanceRef.current;
      quill.on('text-change', (delta, oldDelta, source) => {
        if (source === 'user') {
          const content = quill.root.innerHTML;
          onChangeRef.current(content);
        }
      });
    }
  }, [modules]);

  useEffect(() => {
    const quill = quillInstanceRef.current;
    if (quill && value !== quill.root.innerHTML) {
      const delta = quill.clipboard.convert(value);
      // quill.setContents(delta, 'silent');
      quillInstanceRef.current.clipboard.dangerouslyPasteHTML(value);
    }
  }, [value]);

  return <div ref={editorContainerRef} style={{ minHeight: '150px' }} />;
};

export default QuillWrapper;